import { useMemo, useState } from 'react';
import styled from 'styled-components';

import Keyword from '../../Shared/Keyword';
import Switch from '../../Shared/Switch';
import { Autocomplete } from '../../../healtheraComponents';

export default function Categories({ categories, value, onChange }) {
  const [inputValue, setInputValue] = useState('');

  const { fixedCategories, rigidCategories } = useMemo(() => {
    return categories.reduce((acc, category) => {
      if (category.metadata?.position_locked) acc.fixedCategories.push(category);
      if (!category.metadata?.position_locked) acc.rigidCategories.push(category);
      return acc;
    }, { fixedCategories: [], rigidCategories: [] })
  }, [categories]);

  const categoryTitleById = useMemo(() => {
    return categories.reduce((acc, category) => {
      acc[category._id] = category.title;
      return acc;
    }, {});
  }, [categories]);

  const checkedCategories = new Set(value);
  const notSelectedRigidCategories = rigidCategories.filter(
    (category) => !checkedCategories.has(category._id)
  );

  function toggleCategory(categoryId) {
    if (checkedCategories.has(categoryId)) {
      checkedCategories.delete(categoryId);
      onChange([...checkedCategories.values()]);
      return;
    }

    onChange([...checkedCategories.values(), categoryId]);
  }

  return (
    <>
      {fixedCategories?.length > 0 && (
        <FixedCategoriesContainer>
          {fixedCategories.map((category) => (
            <Switch
              key={category._id}
              label={category.title}
              value={category._id}
              checked={checkedCategories.has(category._id)}
              onChange={() => toggleCategory(category._id)}
              reverseOrder
              withPadding={false}
              style={{ justifyContent: 'start', backgroundColor: '#F5F5F5', padding: '5px 0' }}
            />
          ))}
        </FixedCategoriesContainer>
      )}
      {rigidCategories?.length > 0 && (
        <Autocomplete
          options={notSelectedRigidCategories.map(category => ({ value: category._id, label: category.title }))}
          onChange={(selected) => { toggleCategory(selected.value); setInputValue(''); }}
          onInputChange={setInputValue}
          value={inputValue}
        />
      )}
      {value?.length > 0 && (
        <TagsContainer>
          {value.map((categoryId) => (
            <Keyword
              keyword={categoryTitleById[categoryId]}
              onRemove={() => toggleCategory(categoryId)}
              key={categoryId}
            />
          ))}
        </TagsContainer>
      )}
    </>
  );
}

const FixedCategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px 10px;
`;
